import _findIndex from 'lodash/findIndex';
import _property from 'lodash/property';
import { DEFAULT_PAGE_SIZE, ROW_HEIGHT, PLACE_HOLDER_HEIGHT, MAX_MENU_LIST_HEIGHT } from './menuList.constants';
export var getMenuHeight = function getMenuHeight(optionSize) {
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PAGE_SIZE;
  var placeholderHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PLACE_HOLDER_HEIGHT;
  if (optionSize === 0) {
    return placeholderHeight;
  }
  var height = optionSize < pageSize ? optionSize * ROW_HEIGHT : pageSize * ROW_HEIGHT;
  if (height > MAX_MENU_LIST_HEIGHT) {
    return MAX_MENU_LIST_HEIGHT;
  }
  return height;
};